import { createContext, ReactNode, useContext, useMemo } from 'react';
import { UserService } from '../services/UserService';

export const UserServiceContext = createContext<UserService | undefined>(undefined);

export function UserServiceProvider({ children }: { readonly children: ReactNode }) {
  const service = useMemo(() => new UserService(), []);
  return <UserServiceContext.Provider value={service}>{children}</UserServiceContext.Provider>;
}

export function useUserService(): UserService {
  const context = useContext(UserServiceContext);
  if (!context) {
    throw new Error('useUserService must be used within UserServiceProvider');
  }
  return context;
}
